type IOptions =
  | {
      capitalize: 'first' | 'none' | 'upper'
      space: 'camelCase'
    }
  | {
      capitalize?: 'all' | 'first' | 'none' | 'upper'
      space?: 'none' | 'space'
    }

export const formatSnakeCase = (
  word: string,
  options: IOptions = { capitalize: 'none', space: 'none' },
) => {
  const words = word.split('_')

  const capitalize = (word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()

  const formattedWords = () =>
    words.map((w, index) => {
      // Apply capitalization based on options
      switch (options.capitalize) {
        case 'all':
          return capitalize(w)
        case 'first':
          return index === 0 ? capitalize(w) : w.toLowerCase()
        case 'upper':
          return w.toUpperCase()
        case 'none':
        default:
          return w.toLowerCase()
      }
    })

  // Apply spacing based on options
  switch (options.space) {
    case 'camelCase':
      if (options.capitalize === 'none') {
        // Special handling to ensure the first word is lowercased in camelCase
        return formattedWords()
          .map((w, index) => (index === 0 ? w : capitalize(w)))
          .join('')
      }

      return formattedWords().join('')
    case 'none':
      return formattedWords().join('')
    case 'space':
      return formattedWords().join(' ')
    default:
      return formattedWords().join('_')
  }
}
